import React from 'react';
import {OverlayContainer} from "../components/overlay";
import {useSelfieUploadState} from "../selfie_context";
import {FileSelect} from "../components/file_select";
import {CameraRecording} from "./camera_recording";
import classNames from "classnames";

export const MediaSourceSelect = () => {
  const [selectedSource, setSelectedSource] = React.useState(null)
  const {mode, mediaSelectButtonOrientation} = useSelfieUploadState()
  const inputRef = React.useRef(null)

  const handleClickSelectFile = () => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  if (selectedSource === "camera") {
    return <CameraRecording/>
  }

  return <OverlayContainer>
    <FileSelect ref={inputRef}/>
    <div className={classNames("d-flex gap-3 selfie-media-select-button-container", {
      "flex-column": mediaSelectButtonOrientation === "vertical",
      "flex-row justify-content-around": mediaSelectButtonOrientation === "horizontal"
    })}>
      <button
        type={"button"}
        className={"btn btn-light m-2 selfie-media-select-camera-button"}
        onClick={() => setSelectedSource("camera")}>
        <i className={classNames("fa fa-2x p-3", {"fa-camera": mode === "image", "fa-video": mode === "video"})}></i>
      </button>
      <button type={"button"} className={"btn btn-light m-2 selfie-media-select-file-button"}
              onClick={handleClickSelectFile}>
        <i className="fa fa-file fa-2x p-3"></i>
      </button>
    </div>
  </OverlayContainer>
}